import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../i18n/i18n';
import { addEquipment } from '../../../../redux/Slices/EquipmentSlice';

const AddEquipment = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isRTL = i18n.language === 'ar';
  const [form, setForm] = useState({
    name_ar: '',
    name_en: '',
    code: '',
    quantity: 1,
    is_active: true,
    notes: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name_ar || !form.name_en) {
      toast.error(t('equipments.add.messages.fieldsRequired'), { rtl: isRTL });
      return;
    }
    try {
      setIsSubmitting(true);
      await dispatch(addEquipment(form)).unwrap();
      toast.success(t('equipments.add.messages.addSuccess'), { rtl: isRTL });
      navigate('/equipments');
    } catch (error) {
      toast.error(error || t('equipments.add.messages.addError'), { rtl: isRTL });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{ ...pageStyle, direction: isRTL ? 'rtl' : 'ltr' }}>
      <div style={{ ...cardStyle, direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : 'left' }}>
        <h2 style={{ marginBottom: 20, fontSize: '20px' }}>{t('equipments.add.title')}</h2>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={gridStyle}>
            {isRTL ? (
              <>
                <Input label={t('equipments.add.nameAr')} name="name_ar" value={form.name_ar} onChange={handleChange} required isRTL={true} />
                <Input label={t('equipments.add.nameEn')} name="name_en" value={form.name_en} onChange={handleChange} required isRTL={false} />
              </>
            ) : (
              <>
                <Input label={t('equipments.add.nameEn')} name="name_en" value={form.name_en} onChange={handleChange} required isRTL={false} />
                <Input label={t('equipments.add.nameAr')} name="name_ar" value={form.name_ar} onChange={handleChange} required isRTL={true} />
              </>
            )}
          </div>
          <div style={gridStyle}>
            <Input label={t('equipments.add.code')} name="code" value={form.code} onChange={handleChange} isRTL={isRTL} />
            <Input
              label={t('equipments.add.quantity', { defaultValue: 'الكمية في المخزون' })}
              name="quantity"
              type="number"
              min="0"
              value={form.quantity}
              onChange={handleChange}
              isRTL={isRTL}
            />
          </div>
          <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <span>{t('equipments.add.notes')}</span>
            <textarea
              name="notes"
              value={form.notes}
              onChange={handleChange}
              rows={4}
              style={{
                padding: 12,
                borderRadius: 8,
                border: '1px solid #333',
                backgroundColor: '#1a1f2e',
                color: 'white',
                resize: 'vertical',
                direction: isRTL ? 'rtl' : 'ltr',
                textAlign: isRTL ? 'right' : 'left',
              }}
            />
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, direction: isRTL ? 'rtl' : 'ltr' }}>
            <input type="checkbox" name="is_active" checked={form.is_active} onChange={handleChange} />
            {t('equipments.add.active')}
          </label>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexDirection: isRTL ? 'row' : 'row-reverse' }}>
            <button type="submit" style={submitButtonStyle} disabled={isSubmitting}>
              {isSubmitting ? t('equipments.add.saving') : t('equipments.add.save')}
            </button>
            <button type="button" style={secondaryButtonStyle} onClick={() => navigate('/equipments')}>
              {t('equipments.add.cancel')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const Input = ({ label, isRTL, ...rest }) => (
  <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
    <span style={{ fontSize: 14 }}>{label}</span>
    <input
      {...rest}
      style={{
        padding: 12,
        borderRadius: 8,
        border: '1px solid #333',
        backgroundColor: '#1a1f2e',
        color: 'white',
        direction: isRTL !== undefined ? (isRTL ? 'rtl' : 'ltr') : 'inherit',
        textAlign: isRTL !== undefined ? (isRTL ? 'right' : 'left') : 'inherit',
      }}
    />
  </label>
);

const pageStyle = {
  padding: 30,
  backgroundColor: '#14263b',
  minHeight: 'calc(100vh - 80px)',
  color: 'white',
  display: 'flex',
  justifyContent: 'center',
};

const cardStyle = {
  width: '100%',
  maxWidth: 700,
  backgroundColor: '#1b3350',
  borderRadius: 12,
  padding: 24,
  border: '1px solid #333',
};

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: 16,
};

const submitButtonStyle = {
  backgroundColor: '#AC2000',
  color: 'white',
  border: 'none',
  padding: '12px 18px',
  borderRadius: 8,
  cursor: 'pointer',
  minWidth: 120,
};

const secondaryButtonStyle = {
  backgroundColor: 'transparent',
  color: 'white',
  border: '1px solid #444',
  padding: '12px 18px',
  borderRadius: 8,
  cursor: 'pointer',
  minWidth: 120,
};

export default AddEquipment;

